






import { Component, Vue, Prop } from 'vue-property-decorator';

import { Company } from '../models/company';
import { Layout } from '../models/layout';

@Component
export default class EmployeeLayoutView extends Vue {
  @Prop()
  company!: Company;

  @Prop()
  layout!: Layout;
}
